import classNames from "classnames";
import URI from "urijs";
import { Link as RouterLink } from "react-router-dom";
import React from "react";
import { isInternalLink } from "../../../utils/link.utils";
import Icon from "../icon/Icon";
import "../button/Button.scss";
import "./Link.scss";
import { ReactComponent as ChevronRight } from "../../../assets/img/icons/chevron-right.svg";
/**
 * The link component generates a link. If you want a button to navigate away form the current view, you can use the
 * Link component and apply the renderButton mixin to it. The doormat has a nice example for this. The chevron prop
 * determines if (and where) a chevron should be placed.
 */
export class Link extends React.Component<any, any> {
  availableIcons: {} = {
    "chevron-right": ChevronRight
  };
  constructor(props) {
    super(props);

    this.state = {
      isInternal: props.href && isInternalLink(props.href)
    };
  }

  static getDerivedStateFromProps(newProps, oldState) {
    if (newProps.href) {
      const isInternal = isInternalLink(newProps.href);
      if (oldState.isInternal !== isInternal) {
        return { isInternal };
      }
    }

    return null;
  }

  getRelativeUrL(href) {
    if (!href) return null;

    const uri = URI.parse(href);
    const parts = {
      path: uri.path,
      query: uri.query,
      fragment: uri.fragment
    };

    return URI.build(parts);
  }

  render() {
    const {
      name,
      children,
      className,
      chevron = "none",
      href,
      ...rest
    } = this.props;
    const fullClassName = classNames(
      "link",
      name && `link__${name}`,
      { "link--has-icon": chevron !== "none" },
      className
    );

    const LinkInner = (
      <>
        {chevron === "before" && (
          <Icon
            name="chevron-right"
            size="xsmall"
            iconComponent={this.availableIcons["chevron-right"]}
          />
        )}
        {chevron === "none" ? children : <span>{children}</span>}
        {chevron === "after" && (
          <Icon
            name="chevron-right"
            size="xsmall"
            iconComponent={this.availableIcons["chevron-right"]}
          />
        )}
      </>
    );

    const linkAttrs = {
      className: fullClassName,
      rel: "noopener",
      ...rest
    };

    return this.state.isInternal ? (
      <RouterLink {...linkAttrs} to={this.getRelativeUrL(href)}>
        {LinkInner}
      </RouterLink>
    ) : (
      <a {...linkAttrs} href={href}>
        {LinkInner}
      </a>
    );
  }
}

export default Link;
